require('./brokerMostPopularOfMonth.scss');

const PropTypes = require('prop-types');
const candado_icon = require('assets/icons/icon-candado.svg')

// @vendors
const React = require('react');
const { connect } = require('react-redux');
// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getPublicSitePathByLanguaje } = require('core/apiURLBuilder');
const {
    BROKER_MOST_POPULAR_OF_MONTH_DEFAULT_TAB,
    BROKER_MOST_POPULAR_OF_MONTH_PLANS_TAB,
    BROKER_MOST_POPULAR_OF_MONTH_FUNDS_TAB,
    BROKER_HIRE_PENSION_PLAN_URL,
    MYPROFILE_BROKER_EXPLORE_URL,
    TYPE_PLANS,
    TYPE_FUNDS
} = require('constants/index');
const fundsTableVariation = 'funds';
const plansTableVariation = 'plans';
const { formatAmount } = require('utilities/currencyHelper');
const { buildLinks } = require('utilities/fundsHelper');
const DateHelper = require('utilities/dateHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerMiFIDUSPersonLinkButton = require('mifid/components/brokerMiFIDUSPersonLinkButton/brokerMiFIDUSPersonLinkButton');
const CmToggle = require('wealth-cm/components/cmToggle/cmToggle');
const WebappRender = require('components/conditionalRender/webappRender');

// @ actions
const mostPopularOfMonthActions = require('actions/brokerMostPopularOfMonth');
const BrokerProductFiltersSearchActions = require('actions/brokerProductFiltersSearch');

// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { TabbedContentBox } = require('commonsComponents/tabbedContentBox');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

class BrokerMostPopularOfMonth extends React.Component {

    componentDidMount() {
        const { requestMostPopularOfMonth } = this.props;
        requestMostPopularOfMonth();
    }

    buildBuyProductPath(immItem, type) {
        switch (type) {
            case 'plans':
                return BROKER_HIRE_PENSION_PLAN_URL + immItem.get('customInstitutionSecurityId');
            case 'funds':
                return `/myprofile/broker/buyInvestmentFunds/${immItem.get(
                    'customInstitutionSecurityId'
                )}`;
        }
    }

    buildTable(variation, type) {
        const { immBrokerMostPopularOfMonth } = this.props;
        let fundsTable = <LoadingSection />;
        if (
            !immBrokerMostPopularOfMonth.get('isFetching') &&
            !immBrokerMostPopularOfMonth.get('error') &&
            immBrokerMostPopularOfMonth.get('fetchSuccess') &&
            immBrokerMostPopularOfMonth.get('fetchFundsSuccess') &&
            immBrokerMostPopularOfMonth.get('fetchPlansSuccess')
        ) {
            let immItems = immBrokerMostPopularOfMonth.getIn([variation, 'byOrder']);
            let tableRows;
            let currencyCellHeader;
            let descriptionCellHeader = formatText('broker-mostPopularOfMonthPlansTableHeader');
            let actionButtonLabel = formatText('broker-mostPopularOfMonthPlansActionButtonLabel');
            const rentabilityLastYearLabel = `${formatText('broker-mostPopularOfMonthPlansLastYearProfitability')} ${DateHelper.getFullYear(DateHelper.todayDate()) - 1}`;

            if (variation === fundsTableVariation) {
                currencyCellHeader = (
                    <OKTableCell
                        maxWidth="35"
                        asHeader={true}
                        alignment="center"
                    >
                        <FormattedText value="broker-mostPopularOfMonthCurrencyTableHeader" />
                    </OKTableCell>
                );

                descriptionCellHeader = formatText('broker-mostPopularOfMonthFundsTableHeader');

                actionButtonLabel = formatText('broker-mostPopularOfMonthFundsActionButtonLabel');
            }
            tableRows = immItems.map(itemId => {
                const immItem = immBrokerMostPopularOfMonth.getIn([variation, 'byId', itemId]);
                let productFilePath;
                if (immItem.get('isin') == undefined)
                    productFilePath = getPublicSitePathByLanguaje('brokerURL-brokerURL_pensionPlanOnPublic', {
                        isin: immItem.get('dgsCode')
                    });
                else
                    productFilePath = buildLinks(immItem.get('isin'))

                const buyProductPath = this.buildBuyProductPath(immItem, type);

                const ytd = formatAmount(immItem.get('ytd')) + '%';
                const lastYearRentability = immItem.get('lastYearReturnValue') ? formatAmount(immItem.get('lastYearReturnValue')) + '%': '-';
                let currencyCell;
                let buyButton;



                if (variation === fundsTableVariation) {
                    currencyCell = (
                        <OKTableCell maxWidth="35" alignment="center">
                            {immItem.get('currency')}
                        </OKTableCell>
                    );

                    buyButton = (
                        <BrokerMiFIDUSPersonLinkButton
                            modifier="secondary"
                            size="compact"
                            to={buyProductPath}
                            isinId={immItem.get('isin')}
                        >
                            {actionButtonLabel}
                        </BrokerMiFIDUSPersonLinkButton>
                    );
                } else {
                    buyButton = (
                        <OKButton
                            modifier="secondary"
                            size="compact"
                            to={buyProductPath}
                        >
                            {actionButtonLabel}
                        </OKButton>
                    );
                }

                return (
                    <OKTableRow key={immItem.get('hash')}>
                        <OKTableCell
                            className="broker-most-popular-of-month__description-content-cell"
                            maxWidth="250"
                            truncate={true}
                        >
                            <OKLink
                                to={productFilePath}
                                onClick={() => {
                                    this.props.pageName !== "" &&
                                        taggingEventHandled(this.props.pageName, 'brokerPopular', immItem.get('description'), 'see');
                                }}>
                                {immItem.get('description')}
                            </OKLink>
                        </OKTableCell>
                        <OKTableCell
                            maxWidth="150"
                            truncate={true}
                            width="100"
                        >
                            {immItem.get('category') || '-'}
                        </OKTableCell>
                        <OKTableCell maxWidth="50" alignment="center">
                            {immItem.get('risk')}
                        </OKTableCell>
                        {currencyCell}
                        <OKTableCell width="80" alignment="center">
                            {ytd}
                        </OKTableCell>
                        <OKTableCell width="100" alignment="center">
                            {lastYearRentability}
                        </OKTableCell>
                        <OKTableCell
                            alignment="center"
                            onClick={() => {
                                this.props.pageName !== "" &&
                                    taggingEventHandled(this.props.pageName, 'brokerPopular', immItem.get('description'), 'buy')
                            }}>
                            {buyButton}
                        </OKTableCell>
                    </OKTableRow>
                );
            });

            fundsTable = (
                <OKTable>
                    <thead>
                        <OKTableRow asHeader={true}>
                            <OKTableCell
                                className="broker-most-popular-of-month__description-header-cell"
                                asHeader={true}
                                maxWidth="150"
                            >
                                {descriptionCellHeader}
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                maxWidth="80"
                            >
                                <FormattedText value="broker-mostPopularOfMonthCategoryTableHeader" />
                            </OKTableCell>
                            <OKTableCell
                                alignment="center"
                                asHeader={true}
                                maxWidth="55"
                            >
                                <FormattedText value="broker-mostPopularOfMonthRiskTableHeader" />
                            </OKTableCell>
                            {currencyCellHeader}
                            <OKTableCell
                                alignment="center"
                                asHeader={true}
                                width="80"
                            >
                                <FormattedText value="broker-mostPopularOfMonthYTDTableHeader" />
                            </OKTableCell>
                            <OKTableCell
                                alignment="center"
                                asHeader={true}
                                width="100"
                            >
                                {rentabilityLastYearLabel}
                            </OKTableCell>
                            <OKTableCell
                                alignment="center"
                                asHeader={true}
                            >
                                <FormattedText value="broker-mostPopularOfMonthActionTableHeader" />
                            </OKTableCell>
                        </OKTableRow>
                    </thead>
                    <tbody>
                        {tableRows}
                    </tbody>
                </OKTable>
            );
        }

        return fundsTable;
    }

    buildFundsFooterLinks() {
        const urlCM = formatText('broker-mostPopularOfMonthMoreLink');
        const { resetSpecificProduct } = this.props;
        return (
            <section className="broker-most-popular-of-month__link-box">
                <CmToggle>
                    <WebappRender>
                        <OKLink
                            onClick={()=> {
                                this.props.pageName !== "" &&
                                taggingEventHandled(this.props.pageName, 'buildPortfolio');
                            }}
                            modifier="widget"
                            to={urlCM}
                            extraClass="broker-most-popular-of-month__footer-left-link">
                            <FormattedText value="broker-mostPopularOfMonthMoreCMLinkLabel" />
                        </OKLink>
                    </WebappRender>
                </CmToggle>
                <OKLink
                    modifier="widget"
                    onClick={() => {
                        this.props.pageName !== "" &&
                        taggingEventHandled(this.props.pageName, 'fundsSearch');
                        resetSpecificProduct(TYPE_FUNDS.toUpperCase())
                    }}
                    to={MYPROFILE_BROKER_EXPLORE_URL}>
                    <FormattedText value="broker-mostPopularOfMonthSearchFundsLink" />
                </OKLink>
            </section>
        )
    }

    buildPlansFooterLinks() {
        const { resetSpecificProduct } = this.props;
        return (
            <section className="broker-most-popular-of-month__link-box">
                <OKLink modifier="widget" onClick={() => {
                    this.props.pageName !== "" && taggingEventHandled(this.props.pageName, 'explorePlans');
                    resetSpecificProduct(TYPE_PLANS.toUpperCase());
                }}
                    to={MYPROFILE_BROKER_EXPLORE_URL}
                >
                    <FormattedText value="broker-mostPopularOfMonthMorePlansLinkLabel" />
                </OKLink>
            </section>
        )
    }

    render() {
        const {
            defaultTab,
            deactivateTabsMode,
            disclaimerPlans,
            titleKey,
            toolTipContentKey,
        } = this.props;
        const brokerMostPopularFundsOfMonth = (
            <div>
                <FormattedText
                    value="broker-mostPopularOfMonthFundsTabTitle"
                    className="broker-most-popular-of-month__tab-title broker-most-popular-of-month__tab-title--funds"
                />
                <section>
                    {this.buildTable(fundsTableVariation, 'funds')}
                </section>
            </div>
        );

        const disclaimerPlansSection = disclaimerPlans ? (
            <div className="broker-most-popular-of-month__disclaimer">
                <div className="broker-most-popular-of-month__disclaimer-title">
                    <FormattedText value="broker-mostPopularOfMonthDisclaimer_title" />
                </div>
                <div className="broker-most-popular-of-month__disclaimer-content broker-most-popular-of-month__disclaimer-content-first">
                    <div className="broker-most-popular-of-month__disclaimer-content-icon">
                        <img  src={candado_icon} alt="candado_icon" className="icon-candado broker-risk-information-box-type-seven__warning-icon"/>
                        <img  src={candado_icon} alt="candado_icon" className="icon-candado broker-risk-information-box-type-seven__warning-icon"/>
                    </div>
                    <div className="broker-most-popular-of-month__disclaimer-content-text">
                        <FormattedText value="broker-mostPopularOfMonthDisclaimer_content1" />
                    </div>
                </div>
                <div className="broker-most-popular-of-month__disclaimer-content">
                    <div className="broker-most-popular-of-month__disclaimer-content-icon">
                        <img  src={candado_icon} alt="candado_icon" className="icon-candado broker-risk-information-box-type-seven__warning-icon"/>
                        <img  src={candado_icon} alt="candado_icon" className="icon-candado broker-risk-information-box-type-seven__warning-icon"/>
                    </div>
                    <div className="broker-most-popular-of-month__disclaimer-content-text">
                        <FormattedText value="broker-mostPopularOfMonthDisclaimer_content2" />
                    </div>
                </div>
            </div>
        ) : null;

        const brokerMostPopularPlansOfMonth = (
            <div>
                <FormattedText
                    value="broker-mostPopularOfMonthPlansTabTitle"
                    className="broker-most-popular-of-month__tab-title broker-most-popular-of-month__tab-title--planes"
                />
                <section>
                    {this.buildTable(plansTableVariation, 'plans')}
                    {disclaimerPlansSection}
                </section>
            </div>
        );
        let tables = [brokerMostPopularFundsOfMonth, brokerMostPopularPlansOfMonth];
        let footerContent = [this.buildFundsFooterLinks(), this.buildPlansFooterLinks() ]
        let tableLabels = [
            <div
                onClick={() => taggingEventHandled(this.props.pageName, 'popularTabSelector','funds')}>
                {formatText('broker-mostPopularOfMonthFundsTabName')}
            </div>,
            <div
                onClick={() => taggingEventHandled(this.props.pageName, 'popularTabSelector', 'plans')}>
                {formatText('broker-mostPopularOfMonthPlansTabName')}
            </div>,
        ];
        if (defaultTab === BROKER_MOST_POPULAR_OF_MONTH_PLANS_TAB) {
            tables = [brokerMostPopularPlansOfMonth];
            footerContent = [this.buildPlansFooterLinks()];
            tableLabels = [''];
        }
        if (defaultTab === BROKER_MOST_POPULAR_OF_MONTH_FUNDS_TAB) {
            tables = [brokerMostPopularFundsOfMonth];
            footerContent = [this.buildFundsFooterLinks()];
            tableLabels = [''];
        }

        const iconInfo = (
            <OKTooltip
                target={<i onMouseEnter={() => this.props.pageName && taggingEventHandled(this.props.pageName, 'tooltip')}
                className="icon icon-tooltip broker-most-popular-of-month__tooltip-icon"/>}
                content={toolTipContentKey}
                placement="right"
                offset={[10,0]}
            />
        );

        return (
            <div>
                <TabbedContentBox
                    id="brokerMostPopularOfMonth"
                    customClassName="broker-most-popular-of-month"
                    tabComponents={tables}
                    tabLabels={tableLabels}
                    title={formatText(titleKey)}
                    defaultTabIndex={BROKER_MOST_POPULAR_OF_MONTH_DEFAULT_TAB}
                    extraContent={iconInfo}
                    tabsAsPills={deactivateTabsMode ? false : true}
                    footerContent={footerContent}
                />
            </div>
        );
    }
}

BrokerMostPopularOfMonth.defaultProps = {
    deactivateTabsMode: false,
    disclaimerPlans: false,
    titleKey: 'broker-mostPopularOfMonthTitle',
    toolTipContentKey: 'mostPopularOfMonth-mostPopularOfMonthTooltip',
    pageName:''
};

BrokerMostPopularOfMonth.propTypes = {
    immBrokerMostPopularOfMonth: PropTypes.object.isRequired,
    requestMostPopularOfMonth: PropTypes.func.isRequired,
    defaultTab: PropTypes.number,
    deactivateTabsMode: PropTypes.bool,
    resetSpecificProduct: PropTypes.func.isRequired,
    disclaimerPlans: PropTypes.bool,
    titleKey: PropTypes.string,
    toolTipContentKey: PropTypes.string,
    pageName: PropTypes.string
};

module.exports.constructor = BrokerMostPopularOfMonth;
module.exports.BrokerMostPopularOfMonth = connect(
    state => ({
        immBrokerMostPopularOfMonth: state.brokerMostPopularOfMonth
    }),
    {
        requestMostPopularOfMonth: mostPopularOfMonthActions.requestMostPopularOfMonth,
        resetSpecificProduct: BrokerProductFiltersSearchActions.resetSpecificProduct
    }
)(BrokerMostPopularOfMonth);
